import { datadogRum } from '@datadog/browser-rum';

import { LoginModel } from '../Models/ApplicationModels';
import { environment } from '../environments/environment';

// Datadog RUM session helpers. These used to live in main.ts, which made every importer
// pull the bootstrap entry point into its module graph (a circular import that broke the
// test bundle). They are plain functions with no Angular dependencies.

function initializeDatadog() {
  const config: any = {
    applicationId: environment.datadogAppId,
    clientToken: environment.datadogClientToken,
    site: 'us3.datadoghq.com',
    service: 'productionsystem-web',
    env: environment.environmentName,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  };
  datadogRum.init(config);
  datadogRum.startSessionReplayRecording();
}

export function onUserLogin(user: LoginModel) {
  initializeDatadog();
  datadogRum.setUser({
    id: user.userId.toString(),
    name: user.userName,
    email: user.email
  });
}

export function onUserLogout() {
  datadogRum.clearUser();
}
